module.exports = __webpack_public_path__ + "img/we-are-hiring.e291508b.svg";